(function (app, ng) {

    app.filter("trustAsHtml", ["$sce", function ($sce) {
        return function (str) {
            return $sce.trustAsHtml(str);
        };
    }]);

})(window.app, window.angular); //jshint ignore:line